import {Container, SimpleGrid, Stack, Text, Title, useMantineTheme} from "@mantine/core";
import {useConfig} from "../ConfigContext";
import VentureCard from "../components/venture/VentureCard";

function Ventures() {
    const theme = useMantineTheme();
    const {ventures, home} = useConfig();

    return (
        <Container size="xl" py="xl">
            <Stack gap="xl">
                <Stack gap="sm">
                    <Title order={1} c={theme.colors.brand[6]}>{home.venturesHeading}</Title>
                    <Text size="lg" maw={760}>{home.venturesIntro}</Text>
                </Stack>

                <SimpleGrid cols={{base: 1, sm: 2, lg: 4}} spacing="lg">
                    {ventures.map((venture) => (
                        <VentureCard key={venture.slug} venture={venture}/>
                    ))}
                </SimpleGrid>
            </Stack>
        </Container>
    );
}

export default Ventures;
